import { Card, CardContent, CardHeader, Typography } from "@mui/material";
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import { formatDate } from "@arelia-utils/helpers/dates";
import CardStatus from "@arelia-components/ui-atoms/CardStatus";

type Props = {
  status: string;
  createdDate: string;
};

export default function Status({ status, createdDate }: Props) {

  return (
    <Card sx={styles.card}>
      <CardHeader title="Status" />
      <CardContent>
        <Typography variant="h2" sx={{ textTransform: "capitalize" }}>{status}</Typography>
        <CardStatus color="primary">
          <CalendarTodayOutlinedIcon sx={styles.icon} /> member since {formatDate(createdDate, 'MMMM d, yyyy')}
        </CardStatus>
      </CardContent>
    </Card>
  );
}

const styles = {
  card: {
    gridColumn: "span 4",
    gridRow: "span 3"
  },
  subtitle1: {
    display: "flex",
    alignItems: "center",
    gap: "10px"
  },
  icon: {
    fontSize: "18px"
  }
}